import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PayService } from '../service/pay.service';

@Component({
  selector: 'app-affaire-transfert',
  templateUrl: './affaire-transfert.component.html',
  styleUrls: ['./affaire-transfert.component.css'],
  standalone: false
})
export class AffaireTransfertComponent implements OnInit {
  accountNumber: any;
  sigle: string;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  transferlist: any[] = [];
  allTransfers: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  bDescription: string;
  safeName: string;
  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    $('#utilisateur').DataTable().init;
    this.routerActivate.params.subscribe(params => {
      this.accountNumber = params['id']
    });
    this.sigle = localStorage.getItem('sigle');
    const raw = localStorage.getItem("bDescription");
    this.bDescription = raw ? decodeURIComponent(raw) : '';
    this.safeName = encodeURIComponent(this.bDescription);
    this.initTransfertList()
  }

  initTransfertList() {
    $('#utilisateur').DataTable().destroy();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true
    };

    this.userService.getUtilisateursBussnessTransfertTransaction(this.accountNumber).subscribe(data => {
      this.dtTrigger.next();
      this.allTransfers = Array.isArray(data) ? data : [];
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);
    })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.transferlist = this.allTransfers.filter(t => this.getMonthKey(t?.date) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current); // always include current month
    this.allTransfers.forEach(t => {
      const key = this.getMonthKey(t?.date);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a)) // newest first
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKey(dateInput: any): string {
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) { return ''; }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${d.getFullYear()}-${month}`;
  }

  private getCurrentMonthKey(): string {
    return this.getMonthKey(new Date());
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }

}
